import { baseUrl } from 'utils/axios'
import { Option, Select } from './Select'
import { useQuery } from '@tanstack/react-query'

export const UnitSelect = ({
  onChange,
  value,
  width,
  label,
  placeholder,
}: {
  onChange: (value: Option) => void
  value?: Option | null
  width?: string
  label?: string
  placeholder?: string
}) => {
  const { data: units, isLoading: isLoadingUnits } = useQuery({
    queryKey: ['units'],
    queryFn: async () => {
      const data = await baseUrl.get('/units', {
        params: {
          page: 1,
          limit: 1000,
        },
      })
      console.log(data.data)
      return data.data.map((item) => ({
        label: item.name,
        value: item.id,
      })) as Option[]
    },
  })
  return (
    <Select
      width={width}
      label={label}
      placeholder={placeholder || 'Select unit'}
      options={units || []}
      onChange={(value) => onChange(value)}
      value={
        value
          ? {
              label: value.label,
              value: value.value,
            }
          : null
      }
    />
  )
}
